import { Avatar, Box, Button } from '@mui/material';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { updateGuest } from '../features/inputSlice';

interface Props {
  onSendData: (file: string) => void;
}

const PhotoCapture = (props: Props) => {
  const { t } = useTranslation();
  // const [imageSrc, setImageSrc] = useState<string | null>(null);
  const dispatch = useDispatch();
  const input = useSelector((state: RootState) => state.input);

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        if (reader.result !== null) {
          resolve(reader.result.toString());
        } else {
          reject(new Error('Failed to read file as Base64, result is null'));
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  const handleCapture = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      try {
        const result = await fileToBase64(file);
        dispatch(updateGuest({ id: 0, changes: { certificate: result } }));
      } catch (error) {
        console.error('Error converting file to Base64:', error);
      }
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {!input.guests[0].certificate ? (
        <Button variant="contained" component="label">
          {t(`certificate.camera`)}
          <input type="file" accept="image/*" capture="environment" hidden onChange={handleCapture} />
        </Button>
      ) : (
        <>
          <Avatar src={input.guests[0].certificate} alt="Captured" variant="square" sx={{ width: 200, height: 200, mb: 2 }} />
          <Button variant="contained" color="secondary" onClick={() => dispatch(updateGuest({ id: 0, changes: { certificate: null } }))}>
            {t(`certificate.Retake`)}
          </Button>
        </>
      )}
    </Box>
  );
};

export default PhotoCapture;
